import { colors, makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gridGap: theme.spacing(1.5),
    width: '100%',
    maxWidth: 360,
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 280,
      gridGap: theme.spacing(1),
    },
  },
  input: {
    aspectRatio: '1 / 1',
    width: '100%',
    border: `1px solid ${colors.grey[300]}`,
    borderRadius: theme.spacing(1),
    textAlign: 'center',
    fontSize: 36,
    fontFamily: 'Ubuntu',
    caretColor: 'transparent',
    outline: 'none',
    transition: 'border-color 0.2s',
    '&:focus': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 28,
      borderRadius: theme.spacing(0.75),
    },
  },
  inputError: {
    border: `1px solid ${colors.red[500]}`,
  },
}))

export default styles
